import queryString from 'query-string';
import API from 'services/API';
import strings from 'strings';
import { NotificationsVisibilityOptions } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils/index';

import { showAlert } from './app';
import { makeActionCreator } from './index';

const disableNotificationHistoryAlert = !!process.env.REACT_APP_DISABLE_NOTIFICATION_HISTORY_ALERT;

const { title: titleString } = strings.notifications.error;

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const FETCH_NOTIFICATION_REQUEST = 'FETCH_NOTIFICATION_REQUEST';
export const FETCH_NOTIFICATION_FAILURE = 'FETCH_NOTIFICATION_FAILURE';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const APPLY_NOTIFICATION_PARAMS = 'APPLY_NOTIFICATION_PARAMS';
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';
export const FETCH_TOTAL_SUCCESS = 'FETCH_TOTAL_SUCCESS';
export const CHANGE_NOTIFICATION_VISIBILITY = 'CHANGE_NOTIFICATION_VISIBILITY';
export const CHANGE_NOTIFICATION_TYPE = 'CHANGE_NOTIFICATION_TYPE';

export const markNotificationAsReadClick = makeActionCreator(MARK_NOTIFICATION_READ, 'payload');
export const addNotification = makeActionCreator(ADD_NOTIFICATION, 'payload');
const requestResults = makeActionCreator(FETCH_NOTIFICATION_REQUEST);
const receiveNotificationResults = makeActionCreator(FETCH_NOTIFICATION_SUCCESS, 'payload');
const receiveTotals = makeActionCreator(FETCH_TOTAL_SUCCESS, 'payload');

const failResults = makeActionCreator(FETCH_NOTIFICATION_FAILURE);
const submitQueryParamsNotification = makeActionCreator(APPLY_NOTIFICATION_PARAMS, 'payload');
export const resetNotifications = makeActionCreator(RESET_NOTIFICATIONS);
export const changeNotificationsVisibility = makeActionCreator(
  CHANGE_NOTIFICATION_VISIBILITY,
  'payload'
);
export const changeNotificationsType = makeActionCreator(CHANGE_NOTIFICATION_TYPE, 'payload');

/** Async action to fetch results */
export function getNotifications(
  params = {
    page: 1,
    perPage: 10,
    visibility: NotificationsVisibilityOptions.All
  }
) {
  return dispatch => {
    dispatch(submitQueryParamsNotification(params));
    return dispatch(fetchResults(Endpoints.NotificationHistory, receiveNotificationResults));
  };
}

/** Async action to fetch results */
export function getTotal() {
  return dispatch => {
    return dispatch(fetchTotal(Endpoints.NotificationHistory));
  };
}

/**
 * @param {string} url
 */
const fetchResults = (url, resultsAction) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { params } = state.notification.domain;

    dispatch(requestResults());

    const queryParams = queryString.stringify(params);

    try {
      const { data } = await API.get(`${url}?${queryParams}`);
      dispatch(resultsAction(data));
    } catch (err) {
      dispatch(failResults());
      dispatch(
        showAlert({
          severity: 'error',
          title: titleString,
          body: getErrorMessage(err)
        })
      );
    }
  };
};

/**
 * @param {string} url
 */
const fetchTotal = url => {
  return async dispatch => {
    const queryParams = queryString.stringify({
      page: 1,
      perPage: 1,
      visibility: NotificationsVisibilityOptions.All
    });

    try {
      const { data } = await API.get(`${url}?${queryParams}`);
      dispatch(receiveTotals(data));
    } catch (err) {
      !disableNotificationHistoryAlert &&
        dispatch(
          showAlert({
            severity: 'error',
            title: titleString,
            body: getErrorMessage(err)
          })
        );
    }
  };
};

/** Async action to fetch mark notification as read */
export function markNotificationAsRead(notification) {
  return dispatch => {
    return dispatch(
      fetchMarkNotificationAsRead(
        Endpoints.NotificationMarkAsRead,
        notification,
        markNotificationAsReadClick
      )
    );
  };
}

/**
 * @param {string} url
 * @param {*} data
 */
const fetchMarkNotificationAsRead = (url, data, resultsAction) => {
  const params = {
    notificationId: data.id
  };

  return async dispatch => {
    try {
      await API.post(url, params);
      dispatch(resultsAction(data));
    } catch (err) {
      dispatch(
        showAlert({
          severity: 'error',
          title: titleString,
          body: getErrorMessage(err)
        })
      );
    }
  };
};
